import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import PageHero from "./PageHero";

// Imports zote za picha ziko hapa juu pekee kwa ulinganifu wa kurasa
import heroBg from "../assets/membership.jpg";
import eligibilityImg from "../assets/youth.jpg";
import typesBg from "../assets/orphans.jpg";
import cessationBg from "../assets/homeless.jpg";

import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

export default function MembershipContent(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const m = STRINGS.membershipPage;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initialization space if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="membership-page-wrapper">
                {/* 1. Call PageHero at the Top */}
                <PageHero 
                    kicker={m.hero.kicker[language]} 
                    title={m.hero.title[language]} 
                    bgImage={heroBg} 
                />

                {/* 2. Eligibility Section - Solid Color Style (surfaceColor) */}
                <section className="MainBodySection py-5 mb-solid-section">
                    <div className="container py-4">
                        <div className="row g-4 align-items-center">
                            <div className="col-12 col-md-6">
                                <span className="text-uppercase tracking-wider title-font-light text-muted">{m.eligibility.subtitle[language]}</span>
                                <h2 className="title-font-bold primaryColor-text mt-1 mb-4">{m.eligibility.title[language]}</h2>
                                <p className="font-regular text-darkColor mb-0 lh-lg">
                                    {m.eligibility.desc[language]}
                                </p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="mb-img-wrapper position-relative">
                                    <img src={eligibilityImg} alt="KUKAJA Membership" className="img-fluid w-100 shadow-sm" style={{ border: "3px solid #dee2e6" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 3. Types of Members Section - Image Background with Low Opacity Overlay */}
                <section className="mb-bg-image-section position-relative py-5" style={{ backgroundImage: `url(${typesBg})` }}>
                    <div className="mb-primary-overlay"></div>
                    <div className="container position-relative z-index-3 py-4">
                        <div className="text-center mb-5">
                            <h2 className="title-font-bold text-white text-uppercase m-0">{m.types.title[language]}</h2>
                            <div className="mb-center-line mx-auto mt-2"></div>
                        </div>

                        <div className="row g-4">
                            {/* Founder Members */}
                            <div className="col-12 col-md-6">
                                <div className="mb-transparent-box p-4 h-100">
                                    <h4 className="title-font-semi-bold text-white mb-3">{m.types.founderTitle[language]}</h4>
                                    <p className="font-regular text-white-75 mb-0 lh-base">{m.types.founderDesc[language]}</p>
                                </div>
                            </div>
                            {/* Ordinary Members */}
                            <div className="col-12 col-md-6">
                                <div className="mb-transparent-box p-4 h-100">
                                    <h4 className="title-font-semi-bold text-white mb-3">{m.types.ordinaryTitle[language]}</h4>
                                    <p className="font-regular text-white-75 mb-0 lh-base">{m.types.ordinaryDesc[language]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 4. Rights and Obligations Section - Solid Color Style (backgroundColor) */}
                <section className="MainBodySection py-5" style={{ backgroundColor: "var(--backgroundColor)" }}>
                    <div className="container py-3">
                        <div className="text-center mb-5">
                            <h2 className="title-font-bold primaryColor-text text-uppercase m-0">{m.rights.title[language]}</h2>
                            <div className="mb-primary-line mx-auto mt-2"></div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10">
                                <div className="row g-3">
                                    {m.rights.items.map((item, idx) => (
                                        <div className="col-12" key={idx}>
                                            <div className="mb-right-item p-3 d-flex align-items-start gap-3 bg-white shadow-xs">
                                                <FaCheckCircle className="mt-1 flex-shrink-0" style={{ color: "var(--secondaryColor)" }} size={18} />
                                                <p className="font-regular text-darkColor mb-0">{item[language]}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 5. Cessation Section - Normal Image Background with Overlay */}
                <section className="mb-bg-image-section position-relative py-5" style={{ backgroundImage: `url(${cessationBg})` }}>
                    <div className="mb-dark-overlay"></div>
                    <div className="container position-relative z-index-3 py-4">
                        <div className="text-center mb-4">
                            <h2 className="title-font-bold text-white text-uppercase m-0">{m.cessation.title[language]}</h2>
                            <p className="title-font-light text-white-75 mt-2 mb-0">{m.cessation.subtitle[language]}</p>
                            <div className="mb-center-line mx-auto mt-3"></div>
                        </div>

                        <div className="row g-3 mt-2">
                            {m.cessation.reasons.map((reason, index) => (
                                <div className="col-12 col-sm-6 col-md-4" key={index}>
                                    <div className="mb-cessation-card p-3 h-100 d-flex align-items-start gap-3">
                                        <FaExclamationTriangle className="mt-1 text-warning flex-shrink-0" size={16} />
                                        <div>
                                            <h5 className="title-font-semi-bold text-white mb-1">{reason.title[language]}</h5>
                                            <p className="font-light text-white-75 small mb-0">{reason.desc[language]}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}